import httpClient from '@/utils/httpClient';

export const getAgentStatus = () => httpClient.get('/api/user-agents/dashboard/status');
export const getAgentUsage = (params) => httpClient.get('/api/user-agents/dashboard/usage', { params });
export const getAgentAudit = (params) => httpClient.get('/api/user-agents/dashboard/audit', { params });
export const getAgentTasks = (params) => httpClient.get('/api/user-agents/dashboard/tasks', { params });
export const getAgentTaskRuns = (params) => httpClient.get('/api/user-agents/dashboard/task-runs', { params });
export const getAgentDigest = (params) => httpClient.get('/api/user-agents/dashboard/digest', { params });
export const getAgentLogs = (params) => httpClient.get('/api/user-agents/dashboard/logs', { params });

export const pauseTask = (taskId) => httpClient.post(`/api/user-agents/dashboard/tasks/${taskId}/pause`);
export const resumeTask = (taskId) => httpClient.post(`/api/user-agents/dashboard/tasks/${taskId}/resume`);
export const invokeAgent = (data) => httpClient.post('/api/user-agents/dashboard/invoke', data);

// ===== Team endpoints (hire/retire/invoke per-profile agents) =====
export const getTeam = () => httpClient.get('/api/user-agents/team');
export const hireAgent = (data) => httpClient.post('/api/user-agents/team/hire', data);
export const retireAgent = (userAgentId) => httpClient.delete(`/api/user-agents/team/${userAgentId}`);
export const updateAgentSettings = (userAgentId, data) => httpClient.patch(`/api/user-agents/team/${userAgentId}`, data);
export const invokeTeamAgent = (userAgentId, prompt) => httpClient.post(`/api/user-agents/team/${userAgentId}/invoke`, { Prompt: prompt });
export const getTeamMessages = (userAgentId, limit) => httpClient.get(`/api/user-agents/team/${userAgentId}/messages`, { params: { limit } });

// ===== Agent memory (editable durable facts; Core is source of truth) =====
export const getAgentMemory = (userAgentId) => httpClient.get(`/api/user-agents/team/${userAgentId}/memory`);
export const putAgentMemory = (userAgentId, data) => httpClient.put(`/api/user-agents/team/${userAgentId}/memory`, data);
export const deleteAgentMemory = (userAgentId, kind) => httpClient.delete(`/api/user-agents/team/${userAgentId}/memory/${kind}`);

// ===== Telegram bot setup (manager only) =====
// Validate token via Telegram getMe — returns { Ok, BotUsername, BotId, FirstName, Error }
export const validateTelegramBot = (token) => httpClient.post('/api/user-agents/team/telegram/validate', { Token: token });
// Detect chat_id by polling getUpdates — returns { Ok, ChatId, Error } when user sends /start
export const detectTelegramChatId = (token) => httpClient.post('/api/user-agents/team/telegram/detect-chat', { Token: token });
// Disconnect bot from a manager
export const disconnectTelegramBot = (userAgentId) => httpClient.delete(`/api/user-agents/team/${userAgentId}/telegram`);

// ===== Approvals (human-in-the-loop) =====
// state = 'pending' (default) | 'all'
export const getApprovals = (state = 'pending') => httpClient.get('/api/user-agents/team/approvals', { params: { state } });
// data = { Decision: 'approved'|'rejected'|'edited', Reason?, EditedPreviewJson? }
export const decideApproval = (id, data) => httpClient.post(`/api/user-agents/team/approvals/${id}/decide`, data);

export const getIssues = (params) => httpClient.get('/api/user-agents/issues', { params });
export const getIssue = (id) => httpClient.get(`/api/user-agents/issues/${id}`);
export const createIssue = (data) => httpClient.post('/api/user-agents/issues', data);
export const updateIssue = (id, data) => httpClient.put(`/api/user-agents/issues/${id}`, data);
export const resolveIssue = (id, data) => httpClient.put(`/api/user-agents/issues/${id}/resolve`, data);
export const deleteIssue = (id) => httpClient.delete(`/api/user-agents/issues/${id}`);

export const getGoals = (params) => httpClient.get('/api/user-agents/goals', { params });
export const createGoal = (data) => httpClient.post('/api/user-agents/goals', data);
export const updateGoal = (id, data) => httpClient.put(`/api/user-agents/goals/${id}`, data);
export const updateGoalProgress = (id, data) => httpClient.put(`/api/user-agents/goals/${id}/progress`, data);
export const deleteGoal = (id) => httpClient.delete(`/api/user-agents/goals/${id}`);

export const getDocuments = (params) => httpClient.get('/api/user-agents/documents', { params });
export const getDocument = (id) => httpClient.get(`/api/user-agents/documents/${id}`);
export const createDocument = (data) => httpClient.post('/api/user-agents/documents', data);
export const updateDocument = (id, data) => httpClient.put(`/api/user-agents/documents/${id}`, data);
export const deleteDocument = (id) => httpClient.delete(`/api/user-agents/documents/${id}`);
